import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout';
import { useContactData } from '@/hooks/useContactData';
import { useNavigationData } from '@/hooks/useNavigationData';
import { useSiteData } from '@/hooks/useSiteData';

export function Contact() {
  const { siteData } = useSiteData();
  const { contactInfo } = useContactData();
  const { navigationItems } = useNavigationData();

  return (
    <>
      <Helmet>
        <title>Contact - {siteData.title}</title>
        <meta
          name="description"
          content="Contact Wayland Rod & Gun Club. Find our mailing address, phone number, and email information."
        />
        <meta name="keywords" content="contact, phone, email, address, Wayland Rod Gun Club" />
      </Helmet>

      <Layout contactInfo={contactInfo} navigationItems={navigationItems}>
        <div className="p-4 sm:p-8 space-y-8 sm:space-y-12 max-w-4xl mx-auto">
          {/* Header Section */}
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-cursive text-primary-700 mb-4">Contact Information</h1>
          </div>

          <div className="space-y-8">
            {/* Mailing Address Section */}
            <div className="card-professional">
              <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-4">
                Mailing Address
              </h2>
              <div className="space-y-2 text-foreground/90">
                <p className="font-medium">{contactInfo.name}</p>
                <p>{contactInfo.address}</p>
                <p>
                  {contactInfo.city}, {contactInfo.state} {contactInfo.zipCode}
                </p>
              </div>
            </div>

            {/* Phone Contact Section */}
            <div className="card-professional">
              <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-4">
                Answering Machine
              </h2>
              <div className="space-y-3 text-foreground/90">
                <p className="text-lg font-medium">
                  <a
                    href={`tel:${contactInfo.phone}`}
                    className="text-primary hover:text-primary/80 underline"
                  >
                    {contactInfo.phone}
                  </a>
                </p>
                <p className="text-neutral-700">
                  If leaving a message please include cell phone and email address. We try our best to respond the same day but it may be 24 hours.
                </p>
              </div>
            </div>

            {/* Email Contact Section */}
            <div className="card-professional">
              <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-4">
                E-mail
              </h2>
              <div className="space-y-3 text-foreground/90">
                <div className="space-y-3">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <span className="text-neutral-700 font-medium min-w-[100px]">Information:</span>
                    <a
                      href="mailto:info@waylandgc.org"
                      className="text-primary hover:text-primary/80 font-medium underline"
                    >
                      info@waylandgc.org
                    </a>
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <span className="text-neutral-700 font-medium min-w-[100px]">Webmaster:</span>
                    <a
                      href="mailto:webmaster@waylandgc.org"
                      className="text-primary hover:text-primary/80 font-medium underline"
                    >
                      webmaster@waylandgc.org
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}